{
  "actions": "Действия",
  "hideButtonLabel": "Показать меньше",
  "showAllButtonLabel": "Показать все ({tagCount, number})"
}
